import { secondAxios } from "../../../api/axios";

const verifyVendorRoute = "/po/verify-vendor/";

export const verifyVendor = async (token) => {
  const { data } = await secondAxios.get(verifyVendorRoute + token);
  return data;
};
